<template>
  <div>
    <p class="titleModal">
      {{ $t(`technicalFile.cooling.step0.componentTitle`) }}
    </p>
    <v-row>
      <v-col class="noYPadding">
        <VTextField
          v-model="componentName"
          :label="$t('technicalFile.cooling.step0.componentName')"
          :rules="{ required: true, min: 1, max: 200 }"
          class="text-field-transparent"
          readonly
          outlined
          flat
          data-cy="networkIdentification-name"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="noYPadding">
        <VTextField
          v-model="data.regulatoryIdentification"
          :label="$t('technicalFile.cooling.step0.regulatory')"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          data-cy="networkIdentification-RegulatoryIdentification"

          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        class="noYPadding"
      >
        <div>
          <VDatePicker
            v-model="data.auditDate"
            outlined
            :disabled="readonly"
            flat
            data-cy="network-identification-date"
            :label="$t('technicalFile.cooling.step0.auditDate')"
            @input="updateData"
          />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VDatePicker from '@/components/shared/widgets/forms/VuetifyInputs/VDatePicker';

export default {
    name: 'ComponentIdentification',
    components: {
        VTextField,
        VDatePicker,
    },
    props: {
        componentIdentification: {
            type: Object,
            default: () => {},
        },
        componentName: {
            type: String,
            default: '',
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {},
        };
    },
    watch: {
        componentIdentification: {
            handler() {
                this.data = { ...this.data, ...this.componentIdentification };
                this.data.auditDate = this.data.auditDate && this.data.auditDate.length
                    ? this.data.auditDate : '';
            },
            immediate: true,
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', { componentIdentification: this.data });
        },
    },
};
</script>
  <style lang="scss" scoped>
  .xPadding{
    padding: 0 6rem;
  }
  .noYPadding {
    padding-bottom: 0;
    padding-top: 0;
  }
  @media screen and (max-width: 600px) {
     .xPadding{
        padding: 0;
      }
  }
  </style>
